import { useTranslation } from "@msuite/ui/localization";
import type { Tables } from "@msuite/utils/types";
import { useMemo } from "react";
import UserCard from "@/components/cards/user-card";

/** Props Interface */
interface ProjectTimelineAuditMergeItemProps {
	item: Tables<"projectsAudit">;
}

export function ProjectTimelineAuditMergeItem({ item }: ProjectTimelineAuditMergeItemProps) {
	/** Hooks */
	const { t } = useTranslation();

	const mergedProject = useMemo(() => {
		try {
			if (!item.oldData) return null;
			const mergedProject: Tables<"projects"> =
				typeof item.oldData === "string" ? JSON.parse(`${item.oldData}`) : item.oldData;
			return mergedProject;
		} catch (error) {
			console.error("Error parsing oldData for audit merge item:", error);
			return null;
		}
	}, [item.oldData]);

	/** Render */
	return (
		<div className="v-stack">
			<div className="h-stack">
				<UserCard
					userId={item?.changedBy as string}
					variant="plain"
					fontSize="md"
				/>
				<p>
					{t("projects._merged_project_into_this_project", {
						projectName: mergedProject?.name || "Project",
					})}
					.
				</p>
			</div>
		</div>
	);
}
